module.exports = __webpack_public_path__ + "img/svg/result-loser-button-background.53c0fad4babe96875bf07f1ab3b7663a.svg";